export const aresSelector = (state, registrationNumber) => state.entities.ares.byRegistrationNumber[registrationNumber];
